export default __webpack_public_path__ + "static/media/alertIcon.2896f652.svg";